import { useDispatch, useSelector } from "react-redux";
import Task from "./TaskBulkOrder"
import { useEffect, useState } from "react";
import purchaseOrderOperation from "redux/PurchaseOrder/operations";
import { getTaskHeaderDetails, getTaskItemDetails, saveCancelFleetItem } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";
import userSelectors from "redux/UserProfile/selectors";
import { setOpenAccordionList } from "Store/Component/FleetManagement/FleetManagementAction";

const TaskContainer = (props:any) => {
    const {
        purchaseOrderStepperData,
        activeStepper
    } = props

    const dispatch = useDispatch();
    const dispatchChangeLogs = purchaseOrderOperation.dispatchChangeLogs(dispatch);
    const dispatchAssignToDropdown = purchaseOrderOperation.dispatchAssignToDropdown(dispatch);
    const [cancelledItemFleetId, setCancelledItemFleetId] = useState<any>(0);
    const {openAccordionList}:any = useSelector((state:any)=>({
        openAccordionList: state?.fleetAdminTaskReducer?.openAccordionList
    }))
    useEffect(()=>{
        dispatch(getTaskHeaderDetails(purchaseOrderStepperData?.orderDetailId)) 
        dispatchAssignToDropdown();
    },[])

    const onChangeAccordian = (selectedItems:any) => {
        const filterArray = selectedItems.map((i:any) => {
            return parseInt(i?.substring(15, i.length))
        });
        dispatch(setOpenAccordionList(filterArray))
        if(selectedItems?.length){
            const value =  selectedItems[selectedItems?.length-1];
            const result = value?.substring(15, value.length);
            dispatch(getTaskItemDetails({orderDetailId: purchaseOrderStepperData.orderDetailId, fleetDetailId: result}))
            dispatchChangeLogs(result)  
        }
    }

    return(
        <Task
            taskHeaderDetails = {purchaseOrderStepperData?.taskHeaderDetails}
            onChangeAccordian = {onChangeAccordian}
            activeStepper = {activeStepper}
            setCancelledItemFleetId={setCancelledItemFleetId}
            orderDetailId={purchaseOrderStepperData?.orderDetailId}
            purchaseOrderStepperData = {purchaseOrderStepperData}
        />
    )
}

export default TaskContainer